import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/apiConfig';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Container,
  Box,
} from '@mui/material';

const TransactionReceipts = () => {
  const [receipts, setReceipts] = useState([]);

  useEffect(() => {
    const fetchReceipts = async () => {
      try {
        const res = await axios.get(getApiUrl('/api/kontobewegung'));
        setReceipts(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchReceipts();
  }, []);

  return (
    <Container>
      <Box my={4}>
        <Typography variant="h4" gutterBottom>
          Transaktionsbelege
        </Typography>
        <Typography variant="body1" gutterBottom>
          Transaktionsbelege sind die Exporte des Bankkontos. Ergänzend können Barzahlungen hier angelegt werden.
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Betrag</TableCell>
                <TableCell>Datum</TableCell>
                <TableCell>Mandatsreferenz</TableCell>
                <TableCell>Verwendungszweck</TableCell>
                <TableCell>Zahlungspflichtiger</TableCell>
                <TableCell>Zahlungsempfänger</TableCell>
                <TableCell>Transaktionsart (bar)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {receipts.map((receipt) => (
                <TableRow key={receipt.bewegungsid}>
                  <TableCell>{receipt.bewegungsid}</TableCell>
                  <TableCell>{receipt.bewegungsbetrag}</TableCell>
                  <TableCell>{new Date(receipt.bewegungsdatum).toLocaleDateString()}</TableCell>
                  <TableCell>{receipt.mandatsreferenz}</TableCell>
                  <TableCell>{receipt.verwendungszweck}</TableCell>
                  <TableCell>{receipt.zahlungspflichtiger}</TableCell>
                  <TableCell>{receipt.zahlungsempfaenger}</TableCell>
                  <TableCell>{receipt.bewegungsartbar ? 'Bar' : 'Nicht bar'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};

export default TransactionReceipts;
